import { graphql } from '@/generated/gql';

export const NEGOTIATION_DEMAND_CANCEL_MUTATION = graphql(/* GraphQL */ `
  mutation DemandCancel($id: UUID!, $data: TsrctDemandCancelInput) {
    tesseract {
      demand(id: $id) {
        cancel(data: $data) {
          id
          status
          cancellationReason
          cancellationReasonText
        }
      }
    }
  }
`);
